import { useState } from 'react';

export function useSearchAndPagination(onSubmit) {
  const [hasSearched, setHasSearched] = useState(false);

  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };

  return {
    hasSearched,
    onSubmitWithFlag,
  };
}
